import React from 'react';

export function ConsentMsg({ cta = 'Submit<sup>*</sup>' }) {
    return (
        <small className="lh-1">
            By clicking <span dangerouslySetInnerHTML={{ __html: cta }} />, I agree to the{' '}
            <a
                href="https://milanlaser.com/privacy"
                target="_blank"
                rel="noreferrer"
                className="text-decoration-underline fw-bold"
            >
                Privacy Policy
            </a>{' '}
            and{' '}
            <a
                href="https://milanlaser.com/terms"
                target="_blank"
                rel="noreferrer"
                className="text-decoration-underline fw-bold"
            >
                Messaging Terms and Conditions
            </a>{' '}
            (affecting my rights) and consent to receive recurring promotional or informational calls, texts and/or
            emails, which may be automated or use prerecorded or artificial intelligence, from or on behalf of Milan
            Laser about its products and services. Consent to communications is not a condition of purchase, and you may
            reach us via phone at 833-667-2967. Message and data rates may apply. Text HELP for help and STOP to stop.
        </small>
    );
}

export default ConsentMsg;
